import { FormControl, FormGroup, FormLabel, TextField } from "@mui/material";
import { OverstockSettings } from "../../api";
import { PasswordField } from "../controls";

export interface OverstockSettingsControlProps {
  settings?: OverstockSettings;
  onChange: (settings: Partial<OverstockSettings>) => void;
}

export const OverstockSettingsControl = (props: OverstockSettingsControlProps) => {
  const { settings, onChange } = props;

  return (
    <FormControl component="fieldset" sx={{ minWidth: 150 }}>
      <FormLabel component="legend">Overstock settings</FormLabel>
      <FormGroup>
        <TextField label="Username" required variant="standard" value={settings?.username ?? ""} onChange={(e) => onChange({ username: e.target.value })} />
        <PasswordField label="Password" variant="standard" value={settings?.password ?? ""} onChange={(e) => onChange({ password: e.target.value })} />
      </FormGroup>
    </FormControl>
  );
};
